"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProductType = exports.addProductType = exports.getProductType = exports.getProductTypes = void 0;
const getProductTypes = async (supabase) => {
    const { data, error } = await supabase
        .from("product_types")
        .select(`*, orderName:name->>en`);
    if (!error)
        return data;
    return error;
};
exports.getProductTypes = getProductTypes;
const getProductType = async (supabase, id) => {
    const { data, error } = await supabase
        .from("product_types")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getProductType = getProductType;
const addProductType = async (supabase, obj) => {
    const { data, error } = await supabase.from("product_types").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addProductType = addProductType;
const updateProductType = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("product_types")
        .update(obj)
        .eq("id", obj.id);
    if (!error)
        return data;
    return error;
};
exports.updateProductType = updateProductType;
